/* tslint:disable:jsx-no-lambda WI:47696 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { GetStartedListPosition } from '../enums/GetStartedListPosition';
import { TaskButtonProperty } from '../interfaces/TaskButtonProperty';
import { isGetStartedInSideBySideState } from '../selectors/isGetStartedInSideBySideState';

const styles = require('./TaskButtonListView.scss');
const classNames = require('classnames');

@observer
export default class TaskButton extends React.Component<TaskButtonProperty, {}> {
    private buttonElement: HTMLElement;

    componentDidUpdate(previousProp: TaskButtonProperty) {
        if (this.props.completed) {
            if (!previousProp.completed) {
                // If transition from incomplete, delay the transition by 1 second so
                // we can show the delay animation to user
                window.setTimeout(() => {
                    this.buttonElement.style.transitionDelay = '0s';
                }, 1000);
            } else {
                this.buttonElement.style.transitionDelay = '0s';
            }
        }
    }

    render() {
        return (
            <div
                ref={ref => (this.buttonElement = ref)}
                className={classNames(
                    styles.taskWrapper,
                    this.props.listPosition === GetStartedListPosition.ListView
                        ? styles.taskWrapperMarginRight
                        : undefined,
                    isGetStartedInSideBySideState(this.props.listPosition)
                        ? styles.halfWidth
                        : undefined,
                    this.props.visible ? undefined : styles.taskHideDefaultState
                )}
                onClick={evt => {
                    if (this.props.onClick) {
                        this.props.onClick(evt);
                    }
                }}
                onMouseEnter={evt => {
                    if (this.props.onMouseEnter) {
                        this.props.onMouseEnter(evt);
                    }
                }}
                onMouseLeave={evt => {
                    if (this.props.onMouseLeave) {
                        this.props.onMouseLeave(evt);
                    }
                }}>
                <div className={styles.taskHeaderWrapper}>
                    {this.props.headIconSection && (
                        <div
                            className={classNames(
                                styles.taskHeaderIcon,
                                this.props.completed
                                    ? styles.iconCompleteState
                                    : styles.iconPendingStae
                            )}>
                            {this.props.headIconSection}
                        </div>
                    )}
                    {this.props.buttonTextSection && (
                        <div
                            className={classNames(
                                styles.taskHeaderText,
                                this.props.listPosition === GetStartedListPosition.ListView ||
                                    this.props.listPosition === GetStartedListPosition.QuickOption
                                    ? styles.taskHeaderTextEllipsis
                                    : undefined,
                                this.props.completed ? styles.taskHeaderTextCompleted : undefined
                            )}>
                            {this.props.buttonTextSection}
                        </div>
                    )}
                </div>
                {this.props.tailIconSection && (
                    <div className={styles.taskStatusIcon}>{this.props.tailIconSection}</div>
                )}
            </div>
        );
    }
}
